import HomeModel from '@/models/Home';

const GET_YSF_INDEX_INFO = 'GET_YSF_INDEX_INFO';
const GET_INDEX_RESOURCE_INFO = 'GET_INDEX_RESOURCE_INFO';
const GET_INDEX_OPEN_AD_LIST = 'GET_INDEX_OPEN_AD_LIST';
const GET_RETAIL_RESOURCE_INFO = 'GET_RETAIL_RESOURCE_INFO';

/**
 * 获取云闪付专题页
 */
async function getYSFIndexInfo() {
  const payload = await new HomeModel().ysfIndexInfo();
  return {
    type: GET_YSF_INDEX_INFO,
    payload
  }
}

/**
 * 获取H5商城首页数据
 */
async function getIndexResourceInfo() {
  const payload = await new HomeModel().indexResourceInfo();
  return {
    type: GET_INDEX_RESOURCE_INFO,
    payload
  }
}

/**
 * 获取H5商城开屏广告数据
 */
async function getIndexOpenAdList() {
  const payload = await new HomeModel().indexResourceList(3);
  return {
    type: GET_INDEX_OPEN_AD_LIST,
    payload
  }
}

/**
 * 获取H5商城商家端首页数据
 */
async function getRetailResourceInfo(code) {
  const payload = await new HomeModel().retailResourceInfo(code);
  return {
    type: GET_RETAIL_RESOURCE_INFO,
    payload
  }
}

const ACTION_TYPES = {
  GET_YSF_INDEX_INFO,
  GET_INDEX_RESOURCE_INFO,
  GET_INDEX_OPEN_AD_LIST,
  GET_RETAIL_RESOURCE_INFO,
};

const ACTION = {
  getYSFIndexInfo,
  getIndexResourceInfo,
  getIndexOpenAdList,
  getRetailResourceInfo,
};

const Home = {
  ACTION_TYPES,
  ACTION
}

export default Home;